import { atom } from "jotai";

export const mobileNumberAtom = atom("962");

export const isContactActiveAtom = atom(null);
